import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import baseUrl from "../../utils/config";
import * as XLSX from 'xlsx';
import { dropdownOptions } from "../../datatablesource";
import newRequest from "../../utils/newRequest";
import CustomSnakebar from "../../utils/CustomSnakebar";
import { BeatLoader } from 'react-spinners';
import { useTranslation } from "react-i18next";
import { MuiCustomTable } from "../../utils/MuiCustomTable";
const CITIES_IMPORT_HEADERS = ["CityCode", "CityName", "RegionCode"];
const ASSET_CONDITION_IMPORT_HEADERS = ["TblConditionCode", "TblConditionDescription"];
const EMPLOYEE_LIST_IMPORT_HEADERS = ["EmpID", "EmpName", "EmpRegion", "EmpUnit", "EmpDivision"];
const BRAND_LIST_IMPORT_HEADERS = ["tblMajorCode", "TblMakeMainCode", "TblMakeName"];
const DEPARTMENT_IMPORT_HEADERS = ["branchcode", "DAONumber", "BusinessUnit", "BUSINESSGROUP", "HRMapping", "DaoName", "DaoArea"];

const Datatable = ({
  columnsName,
  data,
  title,
  actionColumnVisibility,
  buttonVisibility,
  addNewNavigation,
  apiEndPoint,
  updateBtnNavigation,
  deleteBtnEndPoint,
  checkboxSelectionOption,
  uniqueId,
  detectAddRole,
  loading,
  secondaryColor,
  onImportSuccess,
  getRowClassName,
  // setIsLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [record, setRecord] = useState([]);
  const [message, setMessage] = useState(null);
  const [severity, setSeverity] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  // show snackbar when error sate is changed
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setRecord(() => {
      if (data) {
        setRecord(data.map((item, index) => ({ ...item, id: index + 1 })));
      }
    });

    // set session storrage to save last row data as default in rowdata
    if (checkboxSelectionOption === false) {
      sessionStorage.setItem(
        "selectedRow",
        JSON.stringify(data[data.length - 1])
      );
      
    } else {
      sessionStorage.setItem("otherSelectedRows", JSON.stringify(data[0]));
    }
  }, [data]);

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };
  const handleDelete = async (id, rowdata) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      // if(title === "ASSET CATEGORIES")
      let data;
      switch (uniqueId) {
        case "assetCategoriesId":
          data = {
            TblMAINSUBSeriesNoID:
              rowdata.TblMAINSUBSeriesNoID &&
              rowdata.TblMAINSUBSeriesNoID.toString(),
          };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "User deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "allRolesId":
          let TblUsersRolesID =
            rowdata.TblUsersRolesID && rowdata.TblUsersRolesID.toString();
          data = { TblUsersRolesID: TblUsersRolesID };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "User deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "userAccountId":
          let loginname = rowdata.loginname && rowdata.loginname.toString();
          data = { loginname: loginname };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "User deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "verifedAssetId":
          data = { TagNumber: rowdata.TagNumber };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "User deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "assetConditionId":
          data = {
            TblAssetConditionID:
              rowdata.TblAssetConditionID &&
              rowdata.TblAssetConditionID.toString(),
          };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              setMessage(
                response?.data?.message ?? "Deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "otherAssetsCitiesId":
          const cityCode = rowdata.CityCode != null ? String(rowdata.CityCode).trim() : "";
          newRequest
            .delete(`${deleteBtnEndPoint}/${encodeURIComponent(cityCode)}`)
            .then((response) => {
              setMessage(
                response?.data?.message ?? "Deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "brandListId":
          data = {
            TblMakeListID:
              rowdata.TblMakeListID && rowdata.TblMakeListID.toString(),
          };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              setMessage(
                response?.data?.message ?? "Deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "employeeListId":
          data = {
            EmpID: rowdata.EmpID && rowdata.EmpID.toString(),
          };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              setMessage(
                response?.data?.message ?? "Deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "departmentId":
          data = {
            DAONumber: rowdata.DAONumber && rowdata.DAONumber.toString(),
          };
          newRequest
            .delete(deleteBtnEndPoint, { data })
            .then((response) => {
              setMessage(
                response?.data?.message ?? "Deleted successfully"
              );
              setSeverity("success");
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "allAssetsId":
          const tagNumber = rowdata.TagNumber != null ? String(rowdata.TagNumber).trim() : "";
          newRequest
            .delete(`${deleteBtnEndPoint}/${encodeURIComponent(tagNumber)}`)
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "Asset deleted successfully"
              );
              setSeverity("success");
              setRecord(record.filter((item) => item.id !== id));
              onImportSuccess?.();
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        case "locationTagsId":
          // Get the ID from originalData (the actual API data) or fallback to row id
          const locationTagId = rowdata.originalData?.id || rowdata.id || rowdata.originalData?.Id;
          
          if (!locationTagId) {
            setMessage("Location tag ID not found. Cannot delete.");
            setSeverity("error");
            break;
          }

          // Don't allow deletion of generated entries that haven't been saved
          if (rowdata.isGenerated === true) {
            setMessage("Cannot delete unsaved entries. Please save first or remove from the list.");
            setSeverity("error");
            break;
          }

          newRequest
            .delete(`${deleteBtnEndPoint}/${locationTagId}`)
            .then((response) => {
              console.log(response);
              setMessage(
                response?.data?.message ?? "Location tag deleted successfully"
              );
              setSeverity("success");
              setRecord(record.filter((item) => item.id !== id));
              onImportSuccess?.();
            })
            .catch((error) => {
              setMessage(error?.response?.data?.message ?? error?.message ?? "Something went wrong");
              setSeverity("error");
            });
          break;
        default:
          // do nothing
          break;
      }

      if (uniqueId !== "allAssetsId" && uniqueId !== "locationTagsId") {
        setRecord(record.filter((item) => item.id !== id));
        // alert("User deleted successfully");
      }
    }
  };
  const handleAddRole = async (rowdata) => {
    console.log(rowdata);
    // get userloginid from local session
    let userLoginId = window.sessionStorage.getItem("userLoginID");
    userLoginId = JSON.parse(userLoginId);
    newRequest
      .post("/postUsersRolesAssigned", {
        UserLoginID: userLoginId,
        RoleID: rowdata.RoleID,
        RoleDescription: rowdata.RoleDescription,
      })
      .then((response) => {
        console.log(response);
        setMessage(response?.data?.message ?? "Role added successfully");
        // refresh the data table after adding the role
        setSeverity("success");
        detectAddRole();
      })
      .catch((error) => {
        setMessage(error?.message ?? "Something went wrong");
        setSeverity("error");
      });
  };
  const handleRemoveRole = async (rowdata) => {
    console.log(rowdata.RoleID);
    let data = {
      RoleID: rowdata.RoleID && rowdata.RoleID.toString(),

      UserLoginID: rowdata.UserLoginID && rowdata.UserLoginID.toString(),
    };
    newRequest
      .delete("/DeleteUsersRolesAssignedById", { data })
      .then((response) => {
        console.log(response);
        setMessage(response?.data?.message ?? "Role removed successfully");

        // refresh the data table after adding the role
        setSeverity("success");
        detectAddRole();
      })
      .catch((error) => {
        setMessage(error?.message ?? "Something went wrong");
        setSeverity("error");
      });
  };

  const handleEdit = async (rowData) => {
    // if (updateBtnNavigation) {
    //   navigate(updateBtnNavigation, { state: { stateRowData } });
    // }
    // else {
    // }
    switch (uniqueId) {
      case "assetCategoriesId":
        navigate(
          "/admin/database-config/asset-categories/update-asset-category/" +
            rowData.TblMAINSUBSeriesNoID
        );
        break;
      case "allRolesId":
        navigate(
          "/admin/database-config/all-roles/update-role/" +
            rowData.TblUsersRolesID
        );
        break;
      case "userAccountId":
        navigate(
          `/admin/users-account/update-roles/${rowData?.loginname}/${rowData?.loginfullname}`
        );
        break;
      case "assetConditionId":
        navigate(
          "/admin/database-config/other-assets-condition/update/" +
            (rowData.TblAssetConditionID ?? rowData.id)
        );
        break;
      case "otherAssetsCitiesId":
        navigate(
          "/admin/database-config/other-assets-cities/update/" +
            rowData.CityCode
        );
        break;
      case "brandListId":
        navigate(
          "/admin/database-config/brand-list/update/" + rowData.TblMakeListID
        );
        break;
      case "employeeListId":
        navigate(
          "/admin/database-config/employee-list/update/" + rowData.EmpID
        );
        break;
      case "departmentId":
        navigate(
          "/admin/database-config/department/update/" + rowData.DAONumber
        );
        break;
      case "allAssetsId":
        navigate(
          "/admin/all-assets/update/" + rowData.TagNumber
        );
        break;
      default:
        // do nothing
        break;
    }
  };

  const handleExport = () => {
    // get only the data from the record array which matsch columnsName field

  const dataToExport = selectedRows.length > 0 ? selectedRows : record;
    const data = dataToExport.map((item) => {
      const row = {};
      columnsName.forEach((column) => {
        // Use field name as Excel header to ensure exact matching on import
        // This prevents issues with truncated headers in Excel display
        row[column.field] = item[column.field] ?? "";
      });

      return row;
    });
    // Create a new array that excludes the 'id' field
    const dataWithoutId = data.map(({ id, ...rest }) => rest);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(dataWithoutId); // Pass the new array to the 'json_to_sheet' method
    
    // Set column widths to prevent truncation
    const colWidths = columnsName
      .filter(col => col.field !== 'id')
      .map(col => ({ wch: Math.max(col.width ? col.width / 7 : 15, col.field.length + 2) }));
    ws['!cols'] = colWidths;
    
    XLSX.utils.book_append_sheet(wb, ws, title);
    XLSX.writeFile(wb, `${title}.xlsx`); // Export the file
  };
  const handleRowSelected = (rowdata, rowmeta) => {
    const selectedRowData = rowdata;
    // save selectedRowData to local session storage using setItem()
    if (checkboxSelectionOption === false) {
      sessionStorage.setItem("selectedRow", JSON.stringify(selectedRowData));
    } else {
      sessionStorage.setItem(
        "otherSelectedRows",
        JSON.stringify(selectedRowData)
      );
    }
  };
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const parseCitiesFileToRows = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          if (!rows.length) {
            reject(new Error("File is empty"));
            return;
          }
          const rawHeaders = rows[0].map((h) => (h != null ? String(h).trim() : ""));
          const headerMap = {};
          CITIES_IMPORT_HEADERS.forEach((expected) => {
            const idx = rawHeaders.findIndex(
              (h) => h && String(h).toLowerCase() === expected.toLowerCase()
            );
            if (idx >= 0) headerMap[expected] = idx;
          });
          const missing = CITIES_IMPORT_HEADERS.filter((h) => headerMap[h] === undefined);
          if (missing.length) {
            reject(new Error(`Missing columns: ${missing.join(", ")}. Expected: CityCode, CityName, RegionCode.`));
            return;
          }
          const dataRows = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const cityCode = row[headerMap.CityCode] != null ? String(row[headerMap.CityCode]).trim() : "";
            const cityName = row[headerMap.CityName] != null ? String(row[headerMap.CityName]).trim() : "";
            const regionCode = row[headerMap.RegionCode] != null ? String(row[headerMap.RegionCode]).trim() : "";
            if (cityCode || cityName || regionCode) {
              dataRows.push({ CityCode: cityCode, CityName: cityName, RegionCode: regionCode });
            }
          }
          resolve(dataRows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const parseAssetConditionFileToRows = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          if (!rows.length) {
            reject(new Error("File is empty"));
            return;
          }
          const rawHeaders = rows[0].map((h) => (h != null ? String(h).trim() : ""));
          const headerMap = {};
          const codeIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "tblconditioncode" || String(h).toLowerCase() === "code"));
          const descIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "tblconditiondescription" || String(h).toLowerCase() === "description"));
          if (codeIdx >= 0) headerMap.TblConditionCode = codeIdx;
          if (descIdx >= 0) headerMap.TblConditionDescription = descIdx;
          const missing = ASSET_CONDITION_IMPORT_HEADERS.filter((h) => headerMap[h] === undefined);
          if (missing.length) {
            reject(new Error(`Missing columns. Expected: TblConditionCode (or Code), TblConditionDescription (or Description).`));
            return;
          }
          const dataRows = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const code = row[headerMap.TblConditionCode] != null ? String(row[headerMap.TblConditionCode]).trim() : "";
            const description = row[headerMap.TblConditionDescription] != null ? String(row[headerMap.TblConditionDescription]).trim() : "";
            if (code || description) {
              dataRows.push({ TblConditionCode: code, TblConditionDescription: description });
            }
          }
          resolve(dataRows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const parseEmployeeListFileToRows = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          if (!rows.length) {
            reject(new Error("File is empty"));
            return;
          }
          const rawHeaders = rows[0].map((h) => (h != null ? String(h).trim() : ""));
          const headerMap = {};
          const empIdIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "empid" || String(h).toLowerCase() === "employee id"));
          const empNameIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "empname" || String(h).toLowerCase() === "employee name"));
          const empRegionIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "empregion" || String(h).toLowerCase() === "employee region"));
          const empUnitIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "empunit" || String(h).toLowerCase() === "employee unit"));
          const empDivisionIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "empdivision" || String(h).toLowerCase() === "employee division"));
          if (empIdIdx >= 0) headerMap.EmpID = empIdIdx;
          if (empNameIdx >= 0) headerMap.EmpName = empNameIdx;
          if (empRegionIdx >= 0) headerMap.EmpRegion = empRegionIdx;
          if (empUnitIdx >= 0) headerMap.EmpUnit = empUnitIdx;
          if (empDivisionIdx >= 0) headerMap.EmpDivision = empDivisionIdx;
          if (headerMap.EmpID === undefined || headerMap.EmpName === undefined) {
            reject(new Error(`Missing required columns. Expected: EmpID (or Employee ID), EmpName (or Employee Name). Optional: EmpRegion, EmpUnit, EmpDivision.`));
            return;
          }
          const dataRows = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const empID = row[headerMap.EmpID] != null ? String(row[headerMap.EmpID]).trim() : "";
            const empName = row[headerMap.EmpName] != null ? String(row[headerMap.EmpName]).trim() : "";
            const empRegion = headerMap.EmpRegion !== undefined ? (row[headerMap.EmpRegion] != null ? String(row[headerMap.EmpRegion]).trim() : "") : "";
            const empUnit = headerMap.EmpUnit !== undefined ? (row[headerMap.EmpUnit] != null ? String(row[headerMap.EmpUnit]).trim() : "") : "";
            const empDivision = headerMap.EmpDivision !== undefined ? (row[headerMap.EmpDivision] != null ? String(row[headerMap.EmpDivision]).trim() : "") : "";
            if (empID || empName) {
              dataRows.push({ EmpID: empID, EmpName: empName, EmpRegion: empRegion, EmpUnit: empUnit, EmpDivision: empDivision });
            }
          }
          resolve(dataRows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const parseDepartmentFileToRows = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          if (!rows.length) {
            reject(new Error("File is empty"));
            return;
          }
          const rawHeaders = rows[0].map((h) => (h != null ? String(h).trim() : ""));
          const headerMap = {};
          const findCol = (apiName, ...aliases) => {
            const all = [apiName, ...aliases].map((s) => s.toLowerCase());
            return rawHeaders.findIndex((h) => h && all.includes(String(h).toLowerCase()));
          };
          const branchcodeIdx = findCol("branchcode", "branch code");
          const daoNumberIdx = findCol("daonumber", "department code");
          const businessUnitIdx = findCol("businessunit", "business unit");
          const businessGroupIdx = findCol("businessgroup", "business group");
          const hrMappingIdx = findCol("hrmapping", "hr mapping");
          const daoNameIdx = findCol("daoname", "department name");
          const daoAreaIdx = findCol("daoarea", "department area");
          if (branchcodeIdx >= 0) headerMap.branchcode = branchcodeIdx;
          if (daoNumberIdx >= 0) headerMap.DAONumber = daoNumberIdx;
          if (businessUnitIdx >= 0) headerMap.BusinessUnit = businessUnitIdx;
          if (businessGroupIdx >= 0) headerMap.BUSINESSGROUP = businessGroupIdx;
          if (hrMappingIdx >= 0) headerMap.HRMapping = hrMappingIdx;
          if (daoNameIdx >= 0) headerMap.DaoName = daoNameIdx;
          if (daoAreaIdx >= 0) headerMap.DaoArea = daoAreaIdx;
          if (headerMap.branchcode === undefined || headerMap.DAONumber === undefined || headerMap.DaoName === undefined) {
            reject(new Error("Missing required columns. Expected: branchcode (or Branch Code), DAONumber (or Department Code), DaoName (or Department Name). Optional: BusinessUnit, BUSINESSGROUP, HRMapping, DaoArea."));
            return;
          }
          const dataRows = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const branchcode = row[headerMap.branchcode] != null ? String(row[headerMap.branchcode]).trim() : "";
            const DAONumber = row[headerMap.DAONumber] != null ? String(row[headerMap.DAONumber]).trim() : "";
            const DaoName = row[headerMap.DaoName] != null ? String(row[headerMap.DaoName]).trim() : "";
            const BusinessUnit = headerMap.BusinessUnit !== undefined ? (row[headerMap.BusinessUnit] != null ? String(row[headerMap.BusinessUnit]).trim() : "") : "";
            const BUSINESSGROUP = headerMap.BUSINESSGROUP !== undefined ? (row[headerMap.BUSINESSGROUP] != null ? String(row[headerMap.BUSINESSGROUP]).trim() : "") : "";
            const HRMapping = headerMap.HRMapping !== undefined ? (row[headerMap.HRMapping] != null ? String(row[headerMap.HRMapping]).trim() : "") : "";
            const DaoArea = headerMap.DaoArea !== undefined ? (row[headerMap.DaoArea] != null ? String(row[headerMap.DaoArea]).trim() : "") : "";
            if (branchcode || DAONumber || DaoName) {
              dataRows.push({ branchcode, DAONumber, BusinessUnit, BUSINESSGROUP, HRMapping, DaoName, DaoArea });
            }
          }
          resolve(dataRows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const parseBrandListFileToRows = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });
          if (!rows.length) {
            reject(new Error("File is empty"));
            return;
          }
          const rawHeaders = rows[0].map((h) => (h != null ? String(h).trim() : ""));
          const headerMap = {};
          const majorIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "tblmajorcode" || String(h).toLowerCase() === "major category"));
          const minorIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "tblmakemaincode" || String(h).toLowerCase() === "minor category"));
          const nameIdx = rawHeaders.findIndex((h) => h && (String(h).toLowerCase() === "tblmakename" || String(h).toLowerCase() === "description"));
          if (majorIdx >= 0) headerMap.tblMajorCode = majorIdx;
          if (minorIdx >= 0) headerMap.TblMakeMainCode = minorIdx;
          if (nameIdx >= 0) headerMap.TblMakeName = nameIdx;
          const missing = BRAND_LIST_IMPORT_HEADERS.filter((h) => headerMap[h] === undefined);
          if (missing.length) {
            reject(new Error(`Missing columns. Expected: tblMajorCode (or Major Category), TblMakeMainCode (or Minor Category), TblMakeName (or Description).`));
            return;
          }
          const dataRows = [];
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const tblMajorCode = row[headerMap.tblMajorCode] != null ? String(row[headerMap.tblMajorCode]).trim() : "";
            const TblMakeMainCode = row[headerMap.TblMakeMainCode] != null ? String(row[headerMap.TblMakeMainCode]).trim() : "";
            const TblMakeName = row[headerMap.TblMakeName] != null ? String(row[headerMap.TblMakeName]).trim() : "";
            if (tblMajorCode || TblMakeMainCode || TblMakeName) {
              dataRows.push({ tblMajorCode, TblMakeMainCode, TblMakeName });
            }
          }
          resolve(dataRows);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const handleImport = () => {
    if (!selectedFile) {
      setError(t("Please select a file to import."));
      return;
    }
    if (uniqueId === "assetConditionId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      parseAssetConditionFileToRows(selectedFile)
        .then(async (rows) => {
          if (rows.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }
          let successCount = 0;
          const failed = [];
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            try {
              await newRequest.post("/PostAssetCondition", {
                TblConditionCode: row.TblConditionCode,
                TblConditionDescription: row.TblConditionDescription,
              });
              successCount++;
            } catch (err) {
              failed.push({
                row: i + 2,
                ...row,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }
          setMessage(
            t("Import complete") + ": " + successCount + " / " + rows.length + " " + t("rows imported")
          );
          setSeverity("success");
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length);
          }
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          onImportSuccess?.();
        })
        .catch((err) => {
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (uniqueId === "employeeListId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      parseEmployeeListFileToRows(selectedFile)
        .then(async (rows) => {
          if (rows.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }
          let successCount = 0;
          const failed = [];
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            try {
              await newRequest.post("/PostEmployeeList", {
                EmpID: row.EmpID,
                EmpName: row.EmpName,
                EmpRegion: row.EmpRegion,
                EmpUnit: row.EmpUnit,
                EmpDivision: row.EmpDivision,
              });
              successCount++;
            } catch (err) {
              failed.push({
                row: i + 2,
                ...row,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }
          setMessage(
            t("Import complete") + ": " + successCount + " / " + rows.length + " " + t("rows imported")
          );
          setSeverity("success");
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length);
          }
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          onImportSuccess?.();
        })
        .catch((err) => {
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (uniqueId === "brandListId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      parseBrandListFileToRows(selectedFile)
        .then(async (rows) => {
          if (rows.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }
          let successCount = 0;
          const failed = [];
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            try {
              await newRequest.post("/PostMakeList", {
                tblMajorCode: row.tblMajorCode,
                TblMakeMainCode: row.TblMakeMainCode,
                TblMakeName: row.TblMakeName,
              });
              successCount++;
            } catch (err) {
              failed.push({
                row: i + 2,
                ...row,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }
          setMessage(
            t("Import complete") + ": " + successCount + " / " + rows.length + " " + t("rows imported")
          );
          setSeverity("success");
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length);
          }
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          onImportSuccess?.();
        })
        .catch((err) => {
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (uniqueId === "departmentId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      parseDepartmentFileToRows(selectedFile)
        .then(async (rows) => {
          if (rows.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }
          let successCount = 0;
          const failed = [];
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            try {
              await newRequest.post("/PostNewDepartmentLit", {
                branchcode: row.branchcode,
                DAONumber: row.DAONumber,
                BusinessUnit: row.BusinessUnit,
                BUSINESSGROUP: row.BUSINESSGROUP,
                HRMapping: row.HRMapping,
                DaoName: row.DaoName,
                DaoArea: row.DaoArea,
              });
              successCount++;
            } catch (err) {
              failed.push({
                row: i + 2,
                ...row,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }
          setMessage(
            t("Import complete") + ": " + successCount + " / " + rows.length + " " + t("rows imported")
          );
          setSeverity("success");
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length);
          }
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          onImportSuccess?.();
        })
        .catch((err) => {
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (uniqueId === "otherAssetsCitiesId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      parseCitiesFileToRows(selectedFile)
        .then(async (rows) => {
          if (rows.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }
          let successCount = 0;
          const failed = [];
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            try {
              await newRequest.post("/PostCity", {
                TblCountryID: 1,
                RegionCode: row.RegionCode,
                CityCode: row.CityCode,
                CityName: row.CityName,
              });
              successCount++;
            } catch (err) {
              failed.push({
                row: i + 2,
                ...row,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }
          setMessage(
            t("Import complete") + ": " + successCount + " / " + rows.length + " " + t("rows imported")
          );
          setSeverity("success");
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length);
          }
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          onImportSuccess?.();
        })
        .catch((err) => {
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        })
        .finally(() => {
          setIsLoading(false);
        });
      return;
    }
    if (uniqueId === "allAssetsId") {
      setIsLoading(true);
      setError(null);
      setMessage(null);
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(selectedFile);

      fileReader.onload = async (event) => {
        try {
          const bufferArray = event.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          
          // Read Excel data - use raw option to preserve all values including empty strings
          const allExcelData = XLSX.utils.sheet_to_json(ws, { 
            defval: "",
            raw: false // Convert to strings to preserve values
          });
          
          // Filter out completely empty rows (rows where all values are empty/null/undefined)
          const excelData = allExcelData.filter(row => {
            // Check if row has any non-empty values
            const values = Object.values(row);
            return values.some(val => {
              const strVal = String(val || "").trim();
              return strVal !== "" && strVal !== "null" && strVal !== "undefined";
            });
          });
          
          if (excelData.length === 0) {
            setMessage(t("No data rows found in the file"));
            setIsLoading(false);
            document.getElementById("fileInput").value = "";
            setSelectedFile(null);
            return;
          }

          // Debug: Log Excel headers and first row
          console.log("Excel headers:", Object.keys(excelData[0]));
          console.log("First row data:", excelData[0]);
          console.log("Total rows before filter:", allExcelData.length);
          console.log("Total rows after filter (with data):", excelData.length);

          // Get user login ID from session
          const userLoginId = window.sessionStorage.getItem("userLoginID");
          const parsedUserLoginId = userLoginId ? JSON.parse(userLoginId) : "";

          let successCount = 0;
          const failed = [];

          for (let i = 0; i < excelData.length; i++) {
            const excelRow = excelData[i];
            
            // Skip rows that are completely empty (double check)
            const hasData = Object.values(excelRow).some(val => {
              const strVal = String(val || "").trim();
              return strVal !== "" && strVal !== "null" && strVal !== "undefined";
            });
            
            if (!hasData) {
              console.log(`Skipping empty row ${i + 1}`);
              continue; // Skip this row
            }
            
            const apiData = {};
            
            // Debug: Log row being processed
            if (i < 3) {
              console.log(`Row ${i + 1} Excel data:`, excelRow);
            }

            // Get all Excel column names (keys) from the row
            const excelKeys = Object.keys(excelRow);
            
            // Map each column from our definition to Excel row
            columnsName.forEach((column) => {
              const fieldName = column.field;
              
              // Skip excluded fields
              // MainSubSeriesNo causes validation error - API generates it internally or doesn't need it
              if (fieldName === 'id' || 
                  fieldName === 'majorCategoryAndMinorCategory' || 
                  fieldName === 'MainSubSeriesNo' ||
                  fieldName === 'TblAssetMasterEncodeAssetCaptureID' ||
                  fieldName === 'assetdatecaptured' ||
                  fieldName === 'assetTimeCaptured' ||
                  fieldName === 'assetdatescanned' ||
                  fieldName === 'assettimeScanned') {
                return;
              }
              
              let value = null;
              
              // Strategy 1: Direct match by field name (exact case)
              if (excelRow.hasOwnProperty(fieldName)) {
                value = excelRow[fieldName];
              } 
              // Strategy 2: Case-insensitive match
              else {
                const matchingKey = excelKeys.find(key => 
                  key.toLowerCase() === fieldName.toLowerCase()
                );
                if (matchingKey !== undefined) {
                  value = excelRow[matchingKey];
                }
              }
              
              // Strategy 3: Try header name match (case-insensitive) - only if value not found yet
              if (value === null || value === undefined) {
                if (column.headerName) {
                  const headerMatch = excelKeys.find(key => 
                    key.toLowerCase() === column.headerName.toLowerCase()
                  );
                  if (headerMatch !== undefined) {
                    value = excelRow[headerMatch];
                  }
                }
              }
              
              // Strategy 4: Try partial match for truncated headers - only if value not found yet
              if (value === null || value === undefined) {
                const fieldLower = fieldName.toLowerCase().replace(/\s+/g, '');
                const partialMatch = excelKeys.find(key => {
                  const keyLower = key.toLowerCase().replace(/\s+/g, '');
                  // Check if they start with same prefix (at least 6 characters)
                  const minLen = Math.min(6, Math.min(fieldLower.length, keyLower.length));
                  return minLen > 0 && (
                    fieldLower.substring(0, minLen) === keyLower.substring(0, minLen) ||
                    keyLower.substring(0, minLen) === fieldLower.substring(0, minLen)
                  );
                });
                if (partialMatch !== undefined) {
                  value = excelRow[partialMatch];
                }
              }

              // Process the value - IMPORTANT: Accept empty strings as valid values
              if (value === null || value === undefined) {
                // Only set defaults if value was never found in Excel
                if (fieldName === 'QTY') {
                  value = 1;
                } else if (fieldName === 'cOUNTRY') {
                  value = 'SA';
                } else {
                  value = ""; // Empty string is valid
                }
              } else {
                // Convert to string and trim whitespace, but keep empty strings
                const stringValue = String(value).trim();
                // Only apply defaults if truly empty AND it's a special field
                if (stringValue === "" && fieldName === 'QTY') {
                  value = 1;
                } else if (stringValue === "" && fieldName === 'cOUNTRY') {
                  value = 'SA';
                } else {
                  value = stringValue; // Keep the actual value (even if empty string)
                }
              }

              // Always set the field in API data (even if empty, let API handle validation)
              // EXCEPT for MainSubSeriesNo - exclude it as it causes validation errors
              if (fieldName !== 'MainSubSeriesNo') {
                apiData[fieldName] = value;
              }
            });

            // Add UserLoginID if not present
            if (!apiData.UserLoginID && parsedUserLoginId) {
              apiData.UserLoginID = parsedUserLoginId;
            }

            // Ensure QTY has a value
            if (!apiData.QTY || apiData.QTY === "" || apiData.QTY === 0) {
              apiData.QTY = 1;
            }
            
            // Remove fields that cause validation errors or are auto-generated by API
            // MainSubSeriesNo - API generates this internally or doesn't accept it
            // System fields - these are auto-generated by the API
            delete apiData.MainSubSeriesNo;
            delete apiData.TblAssetMasterEncodeAssetCaptureID;
            delete apiData.assetdatecaptured;
            delete apiData.assetTimeCaptured;
            delete apiData.assetdatescanned;
            delete apiData.assettimeScanned;

            // Final validation: Skip if row has no meaningful data (all fields are empty except defaults)
            const meaningfulFields = Object.keys(apiData).filter(key => {
              const val = apiData[key];
              // Skip default-only fields
              if (key === 'QTY' && val === 1) return false;
              if (key === 'cOUNTRY' && val === 'SA') return false;
              if (key === 'UserLoginID') return false;
              // Check if field has actual data
              const strVal = String(val || "").trim();
              return strVal !== "";
            });

            // If no meaningful fields, skip this row
            if (meaningfulFields.length === 0) {
              console.log(`Skipping row ${i + 1} - no meaningful data`);
              continue;
            }

            // Debug: Log API data being sent for first few rows
            if (i < 3) {
              console.log(`Row ${i + 1} API data:`, apiData);
              console.log(`Row ${i + 1} meaningful fields:`, meaningfulFields);
            }

            try {
              const response = await newRequest.post("/PostAssetMasterEncodeAssetCapture", apiData);
              successCount++;
              // Log successful import
              if (i < 3) {
                console.log(`✓ Successfully imported row ${i + 1}:`, {
                  TagNumber: apiData.TagNumber || 'N/A',
                  Description: apiData.aSSETdESCRIPTION || 'N/A',
                  MajorCategory: apiData.MajorCategory || 'N/A',
                  MinorCategory: apiData.MInorCategory || 'N/A'
                });
              }
            } catch (err) {
              console.error(`✗ Error importing row ${i + 2}:`, err);
              console.error(`Failed row data:`, apiData);
              failed.push({
                row: i + 2,
                excelRow: excelRow,
                apiData: apiData,
                reason: err?.response?.data?.message ?? err?.message ?? "Failed",
              });
            }
          }

          // Show detailed import results
          const importMessage = successCount > 0 
            ? t("Successfully imported") + " " + successCount + " " + (successCount === 1 ? t("row") : t("rows")) + ". " + t("Refreshing list to show all records...")
            : t("No rows were imported");
          
          setMessage(importMessage);
          setSeverity("success");
          
          if (failed.length > 0) {
            setError(t("Some rows failed") + ": " + failed.length + ". Check console for details.");
            console.error("Failed rows:", failed);
          }
          
          // Log detailed summary
          console.log("========================================");
          console.log("📊 IMPORT SUMMARY");
          console.log("========================================");
          console.log(`📄 Total rows in Excel file: ${excelData.length}`);
          console.log(`✅ Successfully imported: ${successCount} NEW row(s)`);
          console.log(`❌ Failed: ${failed.length} row(s)`);
          console.log("========================================");
          console.log("ℹ️  IMPORTANT: After import completes,");
          console.log("   the list will refresh and show ALL records");
          console.log("   (existing records + newly imported ones)");
          console.log("   This is NORMAL behavior.");
          console.log("========================================");
          
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          
          // Refresh the data list after import (shows ALL records)
          if (successCount > 0) {
            console.log("🔄 Refreshing asset list...");
            onImportSuccess?.();
          }
        } catch (err) {
          console.error("Import error:", err);
          setError(err?.message ?? t("Failed to import file"));
          setSeverity("error");
        } finally {
          setIsLoading(false);
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        }
      };

      fileReader.onerror = () => {
        setError(t("Failed to read file"));
        setSeverity("error");
        setIsLoading(false);
        setSelectedFile(null);
        document.getElementById("fileInput").value = "";
      };
      return;
    }
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(selectedFile);

    fileReader.onload = (event) => {
      const bufferArray = event.target.result;
      const wb = XLSX.read(bufferArray, { type: "buffer" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      if (apiEndPoint) {
          setIsLoading(true);
          newRequest
            .post(apiEndPoint, {
              data: data,
            })
            .then((response) => {
              setIsLoading(false);
              console.log(response);
              setMessage(response?.data?.message ?? "Role added successfully");
              // refresh the data table after adding the role
              setSeverity("success");

              const newData = data.map((item, index) => {
                const row = {};

                Object.keys(item).forEach((headerName) => {
                  const column = columnsName.find(
                    (column) =>
                      column.headerName.toLowerCase() ===
                        headerName.toLowerCase() ||
                      column.field.toLowerCase() === headerName.toLowerCase()
                  );
                  if (column) {
                    row[column.field] = item[headerName];
                  } else {
                    console.log(
                      `Field '${headerName}' not found in the table.`
                    );
                  }
                });

                // Set the id of the new row
                row.id = record.length + index + 1;
                return row;
              });

              // Set the new data in the table
              setRecord([...record, ...newData]);
              // Reset the selected file state
              setSelectedFile(null);
              document.getElementById("fileInput").value = "";
              // Call onImportSuccess callback to refresh data
              onImportSuccess?.();
            })
            .catch((error) => {
              setMessage(error?.message ?? "Something went wrong");
              setSeverity("error");
              setIsLoading(false);
            });
        } else {
          const newData = data.map((item, index) => {
            const row = {};

            Object.keys(item).forEach((headerName) => {
              const column = columnsName.find(
                (column) =>
                  column.headerName.toLowerCase() ===
                    headerName.toLowerCase() ||
                  column.field.toLowerCase() === headerName.toLowerCase()
              );
              if (column) {
                row[column.field] = item[headerName];
              } else {
                console.log(`Field '${headerName}' not found in the table.`);
              }
            });

            // Set the id of the new row
            row.id = record.length + index + 1;
            return row;
          });

          // Set the new data in the table
          setRecord([...record, ...newData]);
          // Reset the selected file state
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
          console.log("file reset");
        }
      };

      fileReader.onerror = (error) => {
        console.log("Error reading the file: ", error);
      };
  };

  const CustomCell = (params) => {
    const style = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "auto",
      minWidth: 0, // add this property
      maxWidth: "100%", // add this property
    };
    return <div style={{ ...style, overflowX: "auto" }}>{params.value}</div>;
  };
  const columnsWithCustomCell = columnsName.map((column) => {
    // If column already has a custom renderCell, preserve it
    if (column.renderCell) {
      return column;
    }
    // Otherwise, apply CustomCell for columns with width
    if (column.width) {
      return {
        ...column,
        renderCell: CustomCell,
      };
    }
    return column;
  });

  const actionColumn = [
    {
      field: "action",
      headerName: t("Action"),
      width: 150,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id, params.row)}
            >
              {t("Delete")}
            </div>
            {uniqueId !== "verifedAssetId" && (
              <span
                onClick={() => handleEdit(params.row)}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">{t("Update")}</div>
              </span>
            )}
          </div>
        );
      },
    },
  ];
  const AddBtn = [
    {
      field: "action",
      headerName: t("Action"),
      width: 130,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div
              className="deleteButton"
              onClick={() => handleAddRole(params.row)}
            >
              {t("ADD ROLE")}
            </div>
          </div>
        );
      },
    },
  ];
  const RemoveBtn = [
    {
      field: "action",
      headerName: t("Action"),
      width: 130,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div
              className="deleteButton"
              onClick={() => handleRemoveRole(params.row)}
            >
              {t("REMOVE ROLE")}
            </div>
          </div>
        );
      },
    },
  ];
  const idColumn = [
    {
      field: "id",
      headerName: t("ID"),
      width: checkboxSelectionOption ?? true ? 30 : 60,
    },
  ];

  return (
    <>
      {/* {isLoading && (
        <div
          className="loading-spinner-background"
          style={{
            zIndex: 9999,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
          }}
        >
          <BeatLoader
            size={18}
            color={"#6439ff"}
            // height={4}
            loading={isLoading}
          />
        </div>
      )} */}

      <div className="datatable">
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <div
          className={`datatableTitle ${
            i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
        >
          {title}
          {buttonVisibility !== false && (
            <span className="leftDatatableTitle">
              <Link
                to={addNewNavigation}
                className={`link  ${
                  i18n.language === "ar" ? "mr-16" : "ml-16"
                }`}
              >
                {t("Add New")}
              </Link>
              <button onClick={handleExport}>{t("Export to Excel")}</button>
              <input
                id="fileInput"
                className="chooseFileBtn"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
              />
              <button onClick={handleImport}>
                {t("Import from Excel File")}
              </button>
            </span>
          )}
        </div>
        <MuiCustomTable
          getRowHeight={({}) => {
            let x;
            // title === "USER ACCOUNTS" ? x = 100 : x = 60;
            x = 60;
            return x;
          }}
          getRowClassName={getRowClassName}
          secondaryColor={secondaryColor ? secondaryColor : null}
          loading={loading}
          className="datagrid"
          rows={record}
          // columns={
          //   actionColumnVisibility !== false
          //     ? idColumn.concat(columnsWithCustomCell.concat(actionColumn))
          //     : uniqueId === "userAccountRoleId" ? idColumn.concat(columnsWithCustomCell.concat(AddBtn))
          //       : title === "USER ROLES ASSIGNED" ?
          //         idColumn.concat(columnsWithCustomCell.concat(RemoveBtn)) :
          //         idColumn.concat(columnsWithCustomCell)

          // }
          columns={
            i18n.language === "ar"
              ? (actionColumnVisibility !== false
                  ? idColumn.concat(columnsWithCustomCell.concat(actionColumn))
                  : uniqueId === "userAccountRoleId"
                  ? idColumn.concat(columnsWithCustomCell.concat(AddBtn))
                  : title === "USER ROLES ASSIGNED"
                  ? idColumn.concat(columnsWithCustomCell.concat(RemoveBtn))
                  : idColumn.concat(columnsWithCustomCell)
                ).reverse()
              : actionColumnVisibility !== false
              ? idColumn.concat(columnsWithCustomCell.concat(actionColumn))
              : uniqueId === "userAccountRoleId"
              ? idColumn.concat(columnsWithCustomCell.concat(AddBtn))
              : title === "USER ROLES ASSIGNED"
              ? idColumn.concat(columnsWithCustomCell.concat(RemoveBtn))
              : idColumn.concat(columnsWithCustomCell)
          }
          // pageSize={25}
          pageSizeOptions={[50, 100, { value: -1, label: "All" }]}
          pagination
          // onRowSelected={handleRowSelected}
          onRowClick={(params, rowIdx) => {
            console.log(params, "datadata");
            
            // call your handle function and pass the row data as a parameter
            handleRowSelected(params.row, rowIdx,);
          }}
          // rowsPerPageOptions={[50]}
          checkboxSelection={checkboxSelectionOption ?? true}
        />
      </div>
    </>
  );
};

export default Datatable;
